import { apiCall } from '@/lib/api-client';

export interface SystemConfigItem {
  key: string;
  value: unknown;
  description: string | null;
  updatedAt: string;
  updatedBy: string | null;
  readonly: boolean;
}

export interface SystemConfigListResponse {
  items: SystemConfigItem[];
}

export interface TierThresholdsHistoryRow {
  id: string;
  configKey: string;
  oldValue: unknown;
  newValue: unknown;
  changedByUserId: string;
  changedByName: string | null;
  changedAt: string;
  reason: string;
  effectiveDate: string;
}

export interface PatchSystemConfigBody {
  value: unknown;
  /** Required when key is a HISTORY_TRACKED_KEYS member. */
  reason?: string;
  /** Required when key is a HISTORY_TRACKED_KEYS member. ISO YYYY-MM-DD. */
  effectiveDate?: string;
}

/**
 * v0.6.0 N-Q6 — frontend mirror of backend HISTORY_TRACKED_KEYS set.
 * Edits on these keys trigger the safety modal (warning + reason +
 * effectiveDate + double confirm). Server enforces same restriction.
 */
export const HISTORY_TRACKED_KEYS = new Set<string>([
  'agent_tier_thresholds',
  'uploader_tier_thresholds',
  'agent_daily_target',
  'uploader_daily_target',
  // F5-T1b (GO CEO 2026-08-27): las 8 de plata entran al historial trackeado
  'nav_unit_minutes',
  'nav_min_billable_minutes',
  'nav_l1_max_units_event',
  'nav_l1_max_units_year',
  'nav_l2_max_units_month',
  'nav_timer_max_minutes',
  'nav_timer_delta_threshold_minutes',
  'metrics_cycle_start_day',
]);

export const systemConfigApi = {
  list: () => apiCall<SystemConfigListResponse>('/admin/system-config'),

  patch: (key: string, body: PatchSystemConfigBody) =>
    apiCall<SystemConfigItem>(`/admin/system-config/${encodeURIComponent(key)}`, {
      method: 'PATCH',
      body,
    }),

  history: (key: string) =>
    apiCall<{ items: TierThresholdsHistoryRow[] }>(
      `/admin/system-config/${encodeURIComponent(key)}/history`,
    ),
};
